import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";

import { useActiveConversationContext } from "../../context/ActiveConversationContext";
import useInboxTypingStore from "../../hooks/useInboxTypingStore";
import { getTypingString } from "../../utils";

const typingIndicatorDotClassName =
  "size-1 rounded-full bg-black-400 animate-bounce ";

export default function TypingIndicator() {
  const typingState = useInboxTypingStore((state) => state.typingState);

  const { activeConversation } = useActiveConversationContext();

  const typingProfileIds = activeConversation
    ? typingState[activeConversation.conversation_urn]
    : undefined;

  if (typingProfileIds) {
    const { participants } = activeConversation;

    return (
      <div className="flex gap-2 my-1 items-center">
        <div className="flex">
          {(typingProfileIds.length > 3
            ? typingProfileIds.slice(0, 2)
            : typingProfileIds
          ).map((profileUrn) => {
            const profilePicture = participants.find(
              ({ urn }) => urn === profileUrn,
            ).picture_url;

            return (
              <ProfileImage
                key={profileUrn}
                src={profilePicture}
                size={typingProfileIds.length > 1 ? "xs" : "sm"}
                className="ring-1 ring-white -ml-2 first:ml-0"
              />
            );
          })}
          <RenderIf condition={typingProfileIds.length > 3}>
            <div className="ring-1 ring-white -ml-2 bg-purple-100 text-purple-600 flex items-center justify-center size-6 text-xxs-bold rounded-full">
              {typingProfileIds.length - 2}
            </div>
          </RenderIf>
        </div>

        <div className="flex items-center gap-1.5 rounded-3xl px-3 py-3 bg-black-100 rounded-tl-none text-black-500 font-semibold">
          {getTypingString(typingProfileIds, participants)}
          <div className="flex gap-x-1 px-0.5">
            <span
              className={clsx(
                typingIndicatorDotClassName,
                "[animation-delay:0ms]",
              )}
            />
            <span
              className={clsx(
                typingIndicatorDotClassName,
                "[animation-delay:150ms]",
              )}
            />
            <span
              className={clsx(
                typingIndicatorDotClassName,
                "[animation-delay:300ms]",
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}
